module.exports = __webpack_public_path__ + "static/media/dealy_logo@2x.3c3df0c1.png";